"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Declarative_1 = require("../../utils/Declarative");
var DomWidgets_1 = require("./../DomWidgets");
var TabStyles_1 = require("../../styles/TabStyles");
var FooterHeight = TabStyles_1.TabStyles.Sizing.BaseUnit * 8;
var getStyles = function () {
    return ({
        Footer: {
            paddingLeft: TabStyles_1.TabStyles.Spacing.LargeSpace,
            paddingRight: TabStyles_1.TabStyles.Spacing.LargeSpace,
            paddingTop: 0,
            paddingBottom: 0,
            height: FooterHeight,
            flexShrink: 0
        },
        FooterContent: {
            height: '100%',
        }
    });
};
var DialogFooter = function (props) {
    var styles = getStyles();
    return (react_1.createElement(DomWidgets_1.Block, { 'data-tb-test-id': Declarative_1.testId(props.testId, 'Footer'), style: styles.Footer }, Declarative_1.conditional(!!props.footerContent, react_1.createElement(DomWidgets_1.Block, { style: styles.FooterContent }, props.footerContent))));
};
exports.DialogFooter = DialogFooter;
//# sourceMappingURL=DialogFooter.js.map